export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_DATE_FORMAT = "PPP";
